import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import HomeIcon from "@material-ui/icons/Home";
import ReceiptIcon from "@material-ui/icons/Receipt";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import DashboardIcon from "@material-ui/icons/Dashboard";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import LayersIcon from "@material-ui/icons/SyncProblem";
import ApiService from "../../ApiService";
import ChbkIcon from "@material-ui/icons/SettingsBackupRestore";
import AppRegistrationIcon from "@material-ui/icons/HowToReg";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import SummarizeIcon from "@mui/icons-material/Summarize";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import { styled } from "@mui/material/styles";
import { ListItem } from "@mui/material";
import BallotIcon from "@mui/icons-material/Ballot";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

// Custom styled ListItemButton for child menus with bullet points
const StyledChildListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingLeft: "50px",
  backgroundColor: "transparent",
  "&::before": {
    content: '"\\2022"', // Unicode for bullet point
    position: "absolute",
    left: "35px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "1rem",
    color: theme.palette.text.primary,
  },
  "&.Mui-selected": {
    backgroundColor: "#f0f0f0",
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

// Add style here to style the scrollbar
const StyledList = styled(List)(({ theme, maxHeight, menuWidth }) => ({
  maxHeight: maxHeight - 80,
  overflowX: "hidden",
  overflowY: "auto",
  width: menuWidth,
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: theme.palette.grey[200],
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.grey[500],
    borderRadius: "4px",
    "&:hover": {
      background: theme.palette.grey[600],
    },
  },
  "&::-webkit-scrollbar-thumb:active": {
    background: theme.palette.grey[700],
  },
}));

class MenuComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuItems: [],
      appMenuList: [],
      winWidth: 0,
      winHeight: 0,
      selectedMenuId: null,
      responseMessage: null,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();

    ApiService.fetchMenu().then((res) => {
      this.setState({
        menuItems: res.data,
      });
      this.getLoggedInUserId();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  getLoggedInUserId() {
    ApiService.getCurrentUser().then((res) => {
      const id = res.data.id;
      this.fetchUserMenu(id);
    });
  }

  fetchUserMenu(userId) {
    ApiService.userMenuMappings(userId).then((res) => {
      var icon = <HomeIcon />;
      var Structure = [];
      let dashboardMenuId = null;

      res.data.forEach((item) => {
        if (item.menu.parentId != null) {
          return;
        }
        if (item.menu.icon === "HOME") {
          icon = <HomeIcon />;
        } else if (item.menu.icon === "ONBOARDING") {
          icon = <AppRegistrationIcon />;
        } else if (item.menu.icon === "DASHBOARD") {
          icon = <DashboardIcon />;
        } else if (item.menu.icon === "USERS") {
          icon = <PeopleAltIcon />;
        } else if (item.menu.icon === "MENU_MANAGEMENT") {
          icon = <BallotIcon />;
        } else if (item.menu.icon === "MENU_USAGE") {
          icon = <DataUsageIcon />;
        } else if (item.menu.icon === "ACQUIRER") {
          icon = <AccountBalanceIcon />;
        } else if (item.menu.icon === "AFFILIATE") {
          icon = <SupervisedUserCircleIcon />;
        } else if (item.menu.icon === "MERCHANT") {
          icon = <AccountBoxIcon />;
        } else if (item.menu.icon === "WIRE") {
          icon = <ReceiptIcon />;
        } else if (item.menu.icon === "WIRE_SUMMARY") {
          icon = <SummarizeIcon />;
        } else if (item.menu.icon === "PAYOUT") {
          icon = <MonetizationOnIcon />;
        } else if (item.menu.icon === "REPORTS") {
          icon = <AssessmentIcon />;
        } else if (item.menu.icon === "TRANSACTIONS") {
          icon = <AccountBalanceWalletIcon />;
        } else if (item.menu.icon === "DISPUTE_INFO") {
          icon = <ThumbsUpDownIcon />;
        } else if (item.menu.icon === "CHBKICON") {
          icon = <ChbkIcon />;
        } else if (item.menu.icon === "SUMMARY") {
          icon = <FormatListBulletedIcon />;
        } else if (item.menu.icon === "STATUSUPLOAD") {
          icon = <LayersIcon />;
        } else if (item.menu.icon === "CARDWHITELIST") {
          icon = <CreditCardIcon />;
        } else if (item.menu.icon === "WHITELIST_REPORT") {
          icon = <CreditScoreIcon />;
        } else if (item.menu.icon === "PASSWORD") {
          icon = <LockOpenIcon />;
        } else if (item.menu.icon === "ROLLING_RESERVES") {
          icon = <VolunteerActivismIcon />;
        }

        var link = {
          id: item.menuId,
          title: item.menu.text,
          link: item.menu.link,
          icon: icon,
          role: item.menu.feature.feature,
          open: false,
        };

        if (item.menu.childMenu != null && item.menu.childMenu.length) {
          var childArray = [];
          item.menu.childMenu.map((i) => {
            var childLink = {
              id: i.id,
              title: i.text,
              link: i.link,
            };
            childArray.push(childLink);
          });
          link.items = childArray;
        }
        // Check if this is the dashboard menu item
        if (item.menu.icon === "DASHBOARD") {
          dashboardMenuId = item.menuId;
          link.open = true;
        }
        Structure.push(link);
      });

      // Set dashboard as selected after preparing menu structure
      this.setState(
        {
          appMenuList: Structure,
          selectedMenuId: dashboardMenuId,
        },
        () => {
          // After setting menu items, check if the Dashboard has children and needs to be opened
          const dashboardMenuIndex = this.state.appMenuList.findIndex(
            (menu) => menu.icon === <DashboardIcon />
          );
          if (dashboardMenuIndex > -1) {
            const newMenuList = [...this.state.appMenuList];
            newMenuList[dashboardMenuIndex].open = true;
            this.setState({
              appMenuList: newMenuList,
            });
          }
        }
      );
    });
  }

  updateDimensions = () => {
    this.setState({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  getAllMatchingMenu(menuList, role) {
    return _.filter(menuList, function (c) {
      return c.role === role;
    });
  }

  sendMenuClickToServer = (menuId) => {
    ApiService.trackMenuClick(menuId).then((res) => {
      this.setState({
        responseMessage: res.data.responseMessage,
      });
    });
  };

  renderMenuItem(mIdx, roleObj, menus, onClick) {
    if (roleObj === null || menus === null) return <></>;

    const menuItems = [];
    menus.map((menu, mmIdx) => {
      const hasSubMenu = menu.items && menu.items.length > 0;
      const mKey = "M" + mIdx + "" + mmIdx;
      if (!hasSubMenu) {
        menuItems.push(
          <React.Fragment key={mKey}>
            <ListItemButton
              style={{
                marginTop: "-5px",
                backgroundColor:
                  this.state.selectedMenuId === menu.id
                    ? "#f0f0f0"
                    : "transparent", // Highlight if selected
              }}
              onClick={() => {
                onClick();
                this.props.history.push(menu.link);
                this.sendMenuClickToServer(menu.id);
                this.setState({
                  selectedMenuId: menu.id,
                });
              }}
            >
              <ListItemIcon> {menu.icon} </ListItemIcon>{" "}
              <ListItemText
                sx={{
                  marginLeft: "-10px",
                }}
                primary={menu.title}
              />{" "}
            </ListItemButton>{" "}
          </React.Fragment>
        );
      } else {
        menuItems.push(
          <React.Fragment key={mKey}>
            <ListItemButton
              style={{
                marginTop: "-5px",
                backgroundColor:
                  this.state.selectedMenuId === menu.id
                    ? "#f0f0f0"
                    : "transparent", // Highlight if selected
              }}
              onClick={() => {
                const menuIndex = _.findIndex(this.state.appMenuList, {
                  title: menu.title,
                  role: menu.role,
                });
                if (menuIndex > -1) {
                  const newMenuList = [...this.state.appMenuList];
                  newMenuList[menuIndex].open = !newMenuList[menuIndex].open;
                  newMenuList.splice(menuIndex, 1, newMenuList[menuIndex]);
                  this.setState({
                    appMenuList: newMenuList,
                  });
                }
                this.sendMenuClickToServer(menu.id);
                this.setState({
                  selectedMenuId: menu.id,
                }); // Update selected menu ID
              }}
            >
              <ListItemIcon> {menu.icon} </ListItemIcon>{" "}
              <ListItemText
                sx={{
                  marginLeft: "-10px",
                }}
                primary={menu.title}
              />{" "}
              {menu.open ? <ExpandLess /> : <ExpandMore />}{" "}
            </ListItemButton>
            <Collapse in={menu.open} timeout="auto" unmountOnExit>
              <List component="div" key={mKey + "S" + mIdx} disablePadding>
                {menu.items.map((sMenu, idx) => {
                  const key = mKey + "S" + mIdx + "" + idx;
                  return (
                    <ListItem
                      key={key}
                      sx={{
                        padding: 0,
                      }}
                    >
                      <StyledChildListItemButton
                        selected={this.state.selectedMenuId === sMenu.id}
                        onClick={() => {
                          onClick();
                          this.props.history.push(sMenu.link);
                          this.sendMenuClickToServer(sMenu.id);
                          this.setState({
                            selectedMenuId: sMenu.id,
                          });
                        }}
                      >
                        <ListItemText primary={sMenu.title} />{" "}
                      </StyledChildListItemButton>{" "}
                    </ListItem>
                  );
                })}
              </List>{" "}
            </Collapse>{" "}
          </React.Fragment>
        );
      }
    });
    return menuItems;
  }

  render() {
    const { appMenuList, winHeight } = this.state;
    const { menuWidth, onClick } = this.props;

    return (
      <StyledList maxHeight={winHeight} menuWidth={menuWidth}>
        {this.state.menuItems &&
          this.state.menuItems.map((mi, idx) => {
            return this.renderMenuItem(
              idx,
              mi,
              this.getAllMatchingMenu(appMenuList, mi.feature.feature),
              onClick
            );
          })}{" "}
      </StyledList>
    );
  }
}

export default withRouter(MenuComponent);
